import React, { useContext, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { defaultUserImg, FilterIcon } from '../../helper/imagepath'
import { Button } from 'reactstrap'
import CustomModal from '../../component/customModal'
import AddEditAdminControl from './addEditAdminControl'
import DeletePopup from '../../component/deletePopup'
import FeatherIcon from 'feather-icons-react'
import { itemRender } from '../../helper/paginationfunction'
import StatusPopup from '../../component/statusPopup'
import { appendImageURL, capitalizeAndRemoveUnderscore, formatCustomTrim, handleImageError, toLowerCaseString } from '../../helper/function'
import AdminControlFilter from './adminControlFilter'
import { SpinnerContext } from '../../context/spinnerContext'
import { useDispatch, useSelector } from 'react-redux'
import { deleteAdmin, getAllAdmin, getAllAdminRole, updateAdminActivation } from '../../redux/slices/adminControlSlice'
import { getAllRegion } from '../../redux/slices/regionSlice'
import { errorToast, successToast } from '../../util/Toast/toast'
import TableView from '../../component/common/tableView'

const AdminControl = () => {
  const dispatch = useDispatch()
  const { changeLoader } = useContext(SpinnerContext)
  const { allAdmin } = useSelector(({ adminControl }) => adminControl)
  const [showModal, setShowModal] = useState(false)
  const [showFilter, setShowFilter] = useState(false)
  const [adminID, setAdminID] = useState(null)
  const [isActive, setIsActive] = useState(null)
  const [editData, setEditData] = useState([])
  const [pagesize, setPagesize] = useState(10)
  const [page, setPage] = useState(1)
  const [totalCount, setTotalCount] = useState(null)
  const [isRefresh, setIsRefresh] = useState(true)
  const [filterData, setFilterData] = useState({})

  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false)
  const openDeleteModal = () => setIsDeleteModalOpen(!isDeleteModalOpen)

  const [isStatusModalOpen, setIsStatusModalOpen] = useState(false)
  const openStatusModal = () => setIsStatusModalOpen(!isStatusModalOpen)

  const toggleModal = () => setShowModal(!showModal)

  useEffect(() => {
    if (!isRefresh) {
      return
    }
    const params = {
      page: page,
      limit: pagesize,
      region: filterData?.region,
      admin_type: filterData?.admin_type,
      sort_column: 'created_at',
      sort_order: 'DESC'
    }
    if (filterData?.name) params['name'] = formatCustomTrim(filterData?.name)
    changeLoader(true)
    dispatch(getAllAdmin(params))
      .then(({ payload }) => {
        if (payload?.status === 200) {
          changeLoader(false)
          setIsRefresh(false)
        } else {
          errorToast(payload?.data?.status_message || 'Somthing went wrong!')
          changeLoader(false)
        }
      })
      .catch(() => {
        changeLoader(false)
        setIsRefresh(false)
      })
  }, [page, pagesize, isRefresh, filterData])

  useEffect(() => {
    const fetchData = async () => {
      changeLoader(true)
      try {
        await Promise.all([dispatch(getAllRegion()), dispatch(getAllAdminRole())])
      } catch (err) {
        console.error('Error fetching data:', err)
      } finally {
        changeLoader(false)
      }
    }
    fetchData()
  }, [])

  const onDelete = () => {
    setIsRefresh(false)
    if (adminID) {
      changeLoader(true)
      dispatch(deleteAdmin(adminID)).then(({ payload, error }) => {
        if (payload?.status === 200) {
          changeLoader(false)
          setIsRefresh(true)
          openDeleteModal()
          successToast(payload?.data?.status_message || 'Success!')
        } else {
          openDeleteModal()
          errorToast(payload?.data?.status_message || error?.message)
          changeLoader(false)
        }
      })
    }
  }

  const onStatusChange = () => {
    setIsRefresh(false)
    if (adminID) {
      const data = {
        adminID: adminID,
        data: {
          status: !isActive
        }
      }
      changeLoader(true)
      dispatch(updateAdminActivation(data))
        .then(({ payload, error }) => {
          if (payload?.status === 200) {
            changeLoader(false)
            setIsRefresh(true)
            // openStatusModal()
            const modalElement = document.getElementById('status_modal')
            // const modalInstance = bootstrap.Modal.getInstance(modalElement) || new bootstrap.Modal(modalElement)
            modalElement.hide()
            successToast(payload?.data?.status_message || 'Success!')
          } else {
            errorToast(payload?.data?.status_message || error?.message)
            changeLoader(false)
            openStatusModal()
          }
        })
        .catch(() => {
          changeLoader(false)
          openStatusModal()
        })
    }
  }

  const handlePagination = async (page, pageSize) => {
    setPage(page)
    setPagesize(pageSize)
    setIsRefresh(true)
    // getCategoryDetails(page, pageSize);
  }

  const columns = [
    {
      title: 'No',
      render: (value, item, index) => (page - 1) * pagesize + (index + 1)
    },
    {
      title: 'Admin',
      dataIndex: 'admin_id',
      render: (text, record) => {
        return (
          <div className="table-avatar d-flex align-items-center">
            <div className="avatar avatar-sm me-2">
              <img
                className="avatar-img rounded-circle"
                onError={handleImageError}
                src={record?.profile_image ? appendImageURL(record?.profile_image) : defaultUserImg}
                alt="User Image"
              />
            </div>
            <div>
              <p>{record.first_name + ' ' + record.last_name}</p>
              <span className="lowercase">{toLowerCaseString(record.email)}</span>
            </div>
          </div>
        )
      }
    },
    {
      title: 'Admin Type',
      dataIndex: 'admin_type',
      render: (record) => capitalizeAndRemoveUnderscore(record)
    },
    {
      title: 'Region',
      dataIndex: 'adminRegion',
      key: 'adminRegion',
      width: 500,
      render: (record) => (
        <div className='badge-container'> 
          {record.map((regionItem) => (
            <span key={regionItem.admin_region_id} className="badge badge-pill bg-blue-light text-gray-dark me-1 mb-1">
              {regionItem.region[0].region}
            </span>
          ))}
        </div>
      )
    },
    {
      title: 'Status',
      dataIndex: 'is_active',
      render: (text, record) => (
        <div
          // data-bs-toggle="modal"
          // data-bs-target="#status_modal"
          style={{ cursor: 'pointer' }}
          onClick={() => {
            setAdminID(record.admin_id)
            setIsActive(record.is_active)
            setIsStatusModalOpen(true)
          }}
        >
          <span className="badge badge-pill bg-success-light">{text}</span>
          {record?.is_active === true ? (
            <span className="badge badge-pill bg-success-light">Active</span>
          ) : (
            <span className="badge badge-pill  bg-danger-light text-gray-light">Inactive</span>
          )}
        </div>
      )
    },
    {
      title: 'Action',
      render: (record) => (
        <div className="d-flex align-items-center">
          {
            <Link
              className="btn-action-icon me-2 edit_icon_div"
              onClick={() => {
                setAdminID(record.admin_id)
                const filtered = allAdmin?.admins.find((user) => user?.admin_id === record?.admin_id)
                setEditData(filtered)
                toggleModal()
              }}
            >
              <i className="fe fe-edit d-flex align-items-center justify-content-center" style={{ color: 'primary' }}>
                <FeatherIcon icon="edit" className="icon-primary" />
              </i>
            </Link>
          }
          {
            <Link
              className="btn-action-icon delete_icon_div"
              to="#"
              onClick={() => {
                setAdminID(record.admin_id)
                openDeleteModal()
              }}
              // data-bs-toggle="modal"
              // data-bs-target="#delete_modal"
            >
              <i className="fe fe-trash-2 d-flex align-items-center justify-content-center">
                <FeatherIcon icon="trash-2" color="red" />
              </i>
            </Link>
          }
        </div>
      )
    }
  ].filter(Boolean)

  return (
    <>
      <div className="page-wrapper customers">
        <div className="content container-fluid">
          <div className="page-header">
            <div className="content-page-header">
              <h5>Admin</h5>
              <div className="list-btn">
                <ul className="filter-list">
                  <li>
                    <Link className="btn btn-filters w-auto popup-toggle" onClick={() => setShowFilter(!showFilter)}>
                      <span className="me-2">
                        <img src={FilterIcon} alt="filter" />
                      </span>
                      Filter{' '}
                    </Link>
                  </li>
                  <li>
                    <Button
                      className="btn btn-primary"
                      onClick={() => {
                        setEditData(null)
                        setAdminID(null)
                        toggleModal()
                      }}
                    >
                      <i className="fa fa-plus-circle me-2" aria-hidden="true" />
                      Add Member
                    </Button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <div className="table-card-div">
                <div className="card-table">
                  <div className="card-body purchase">
                    <div className="table-responsive table-hover">
                      <TableView
                        columns={columns}
                        dataSource={allAdmin?.admins || []}
                        scroll={allAdmin?.admins?.length > 0 ? { x: true } : false}
                        paginationConfig={{
                          total: allAdmin?.totalRecords || totalCount,
                          defaultPageSize: allAdmin?.limit || 10,
                          defaultCurrent: allAdmin?.currentPage || 1,
                          current: page,
                          pageSize: pagesize,
                          showSizeChanger: true,
                          pageSizeOptions: [10, 25, 50, 100],
                          onChange: (page, pageSize) => handlePagination(page, pageSize),
                          itemRender: itemRender
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <AdminControlFilter
        setShowFilter={setShowFilter}
        showFilter={showFilter}
        pagesize={pagesize}
        page={page}
        setFilterData={setFilterData}
        setTotalCount={setTotalCount}
        setPagesize={setPagesize}
        setPage={setPage}
        handlePagination={handlePagination}
        setIsRefresh={setIsRefresh}
      />
      <CustomModal isOpen={showModal} toggle={toggleModal} title={editData ? `Edit Admin Account` : `Add Admin Account`} size={'md'}>
        <AddEditAdminControl editData={editData} adminID={adminID} toggle={toggleModal} setIsRefresh={setIsRefresh} />
      </CustomModal>

      {isStatusModalOpen && (
        <StatusPopup isStatusModalOpen={isStatusModalOpen} toggle={openStatusModal}>
          <div className="form-header">
            <h3 className="modal_title_text text-center">Update Activation</h3>
            <p className="modal_highlight_text text-center">Are you sure you want to change Status?</p>
          </div>
          <div className="multi_btn_div">
            <button type="button" className="btn common-outline-btn w-100" onClick={() => setIsStatusModalOpen(false)}>
              Cancel
            </button>
            <button type="submit" className="btn btn-success common-field-btn w-100" onClick={() => onStatusChange()}>
              Change
            </button>
          </div>
        </StatusPopup>
      )}
      {isDeleteModalOpen && (
        <DeletePopup isDeleteModalOpen={isDeleteModalOpen} toggle={openDeleteModal}>
          <div className="multi_btn_div">
            <button type="button" className="btn common-outline-btn w-100" onClick={() => setIsDeleteModalOpen(false)}>
              Cancel
            </button>
            <button type="button" className="btn btn-danger common-field-btn w-100" onClick={() => onDelete()}>
              Delete
            </button>
          </div>
        </DeletePopup>
      )}
    </>
  )
}

export default AdminControl
